<template>
    <div class="calendar-cell calendar-header-cell" :class="{'text-danger': danger}">
        <span v-if="!actions" class="font-medium capitalize">{{ text }}</span>
        <div v-else class="flex justify-between h-full items-center">
            <span class="font-medium capitalize">{{ text }}</span>
            <slot name="extend-actions"></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "CalendarHeaderCell",
    props: {
        title: String,
        day: {
            required: false
        },
        danger: Boolean,
        actions: Boolean
    },
    computed: {
        text() {
            if(this.title) {
                return this.title
            } else {
                return this.$moment(this.day).format('dddd DD MMMM')
            }
        }
    }
}
</script>

<style scoped>

</style>
